// @flow

import clients from './clients';

const tabs = {};

tabs.clients = clients;

export default tabs;
